<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{zielText()}}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>

<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        [class.searchBoxWrapperactive]="showModal()" (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Reisende</span>
            <p>{{zielText()}}</p>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="searchBoxWrapper" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        [class.searchBoxWrapperactive]="showModal()" (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Reisende</span>
            <p>{{zielText()}}</p>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="modeDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #modeDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody w450" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Wann reisen Sie?</span>
            </button>
            <div class="custompopupwrapper-mobile customheight">
                <div class="popupbody" (click)="$event.stopPropagation()">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="resultatwrapper customscroll" (click)="$event.stopPropagation()">
        <div class="searchresbody">
            <div class="titlewrp gap5">
                <img src="../../../../assets/tvg/person.svg" alt="person">
                <span class="stattitle fs18">Erwachsene</span>
            </div>
            <div class="customchipwrapper">
                <button class="custopmchip" [class.custopmchip_active]="nbAdult() === 1" (click)="addAdult(1)">
                    @if(nbAdult() === 1) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>1</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbAdult() === 2" (click)="addAdult(2)">
                    @if(nbAdult() === 2) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>2</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbAdult() === 3" (click)="addAdult(3)">
                    @if(nbAdult() === 3) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>3</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbAdult() === 4" (click)="addAdult(4)">
                    @if(nbAdult() === 4) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>4</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbAdult() === 5" (click)="addAdult(5)">
                    @if(nbAdult() === 5) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>5+</span>
                </button>

            </div>
        </div>

        @if(nbAdult() === 5 || nbChildren() === 4) {
        <div class="infoblock">
            <div class="textblock">
                <img src="../../../../assets/tvg/info.svg" alt="info">
                <span>
                    Wollen Sie mit mehr als vier Erwachsenen oder drei Kindern verreisen? Wollen Sie mehr als ein Zimmer
                    buchen?
                    Unserer Hotline hilft Ihnen gerne dabei weiter.
                </span>
            </div>
            <a class="btnblock" href="tel:{{authGuard.getPartnerTel()}}">
                <img src="../../../../assets/tvg/phone_blue.svg" alt="phone_blue">
                <span>Jetzt anrufen</span>
            </a>
        </div>
        }
        <div class="searchresbody">
            <div class="titlewrp gap5">
                <img src="../../../../assets/tvg/children.svg" alt="children">
                <span class="stattitle fs18">Kinder</span>
            </div>
            <div class="customchipwrapper">
                <button class="custopmchip" [class.custopmchip_active]="nbChildren() === 0" (click)="addChildren(0)">
                    @if(nbChildren() === 0) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>0</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbChildren() === 1" (click)="addChildren(1)">
                    @if(nbChildren() === 1) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>1</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbChildren() === 2" (click)="addChildren(2)">
                    @if(nbChildren() === 2) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>2</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbChildren() === 3" (click)="addChildren(3)">
                    @if(nbChildren() === 3) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>3</span>
                </button>
                <button class="custopmchip" [class.custopmchip_active]="nbChildren() === 4" (click)="addChildren(4)">
                    @if(nbChildren() === 4) {
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    }
                    <span>4+</span>
                </button>

            </div>
        </div>
        <div class="searchresbody">
            @for (item of childrenList();let k = $index; track k) {
            <div class="childrenbox">
                <span class="stattitle altertext">Alter des {{k + 1}}. Kindes bei Rückreise</span>
                <div class="childerage">
                    <button [class.disabled]="!item.age || item.age === 0" (click)="item.age = item.age - 1">
                        <img src="../../../../assets/tvg/minus.svg" alt="minus">
                    </button>
                    <input type="number" [(ngModel)]="item.age" (ngModelChange)="checkAge(item)"
                        placeholder="Alter eingeben (0 - 17)">
                    <button [class.disabled]="item.age === 17" (click)="item.age = item.age + 1">
                        <img src="../../../../assets/tvg/plus.svg" alt="plus">
                    </button>
                </div>
            </div>
            }
        </div>
        <!-- <div class="r-wrapper">
            <span class="r-title noselect">{{'Erwachsene' | i18n | async}}</span>
            <div class="rb-wrapper">
                <button class="btnaddmin" (click)="removeAdult()" [class.disablebtn]="nbAdult() === 1" matRipple>
                    <mat-icon>remove</mat-icon>
                </button>
                <span class="r-count noselect">{{nbAdult}}</span>
                <button class="btnaddmin" (click)="addAdult()" [class.disablebtn]="nbAdult === 8" matRipple>
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <div class="r-wrapper">
            <span class="r-title noselect">{{'Kinder' | i18n | async}}</span>
            <div class="rb-wrapper">
                <button class="btnaddmin" (click)="removeChildrent()" [class.disablebtn]="nbChildren === 0" matRipple>
                    <mat-icon>remove</mat-icon>
                </button>
                <span class="r-count noselect">{{nbChildren}}</span>
                <button class="btnaddmin" (click)="addChildren()" [class.disablebtn]="nbChildren === 8" matRipple>
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <div class="c-wrapper">
            <ng-container *ngIf="nbChildren > 0" [ngTemplateOutlet]="childrens"></ng-container>
        </div> -->
    </div>
    <div class="ubwrapper">
        <button class="custombutton customunfilled w100" [class.disabled]="nbAdult() === 5 || nbChildren() === 4"
            (click)="selected()">Übernehmen</button>
    </div>
</ng-template>

<ng-template #childrens>
    <div class="c-t-wrapper">
        <span>{{'Bitte geben Sie das Alter Ihres Kindes' | i18n | async}}.</span>
    </div>
    <div class="r-wrapper-c">
        <ng-container *ngFor="let ch of childrenList()">
            <div class="c-list-wrapper">
                <div class="c-name">
                    <span class="r-title noselect">{{ch.name}}</span>
                    <span class="r-title-second ">{{'Alter in Jahren' | i18n | async}}</span>
                </div>
                <div class="rb-wrapper">
                    <button class="btnaddmin" (click)="removeChildrentAge(ch)" [class.disablebtn]="ch.age === 0"
                        matRipple>
                        <mat-icon>remove</mat-icon>
                    </button>
                    <select class="c-select" [(ngModel)]="ch.age">
                        <!-- <option value="0">0</option> -->
                        <option value="1">{{'<2'}}< /option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="17">17</option>
                    </select>
                    <button class="btnaddmin" (click)="addChildrenAge(ch)" [class.disablebtn]="nbChildren() === 17"
                        matRipple>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>